var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"crly-m-common-footer-nav-item crly-icon",class:[
    _vm.item.type,
    { on: _vm.showSearchMenu && _vm.item.type == 'search' },
    { favorite_click: _vm.active && _vm.item.type == 'favorite' }
  ],on:{"click":_vm.clickFooterNavItem}},[_c('span',{staticClass:"crly-icon-txt"})])
}
var staticRenderFns = []

export { render, staticRenderFns }